/**
 * Runtime config: production reads window.__ENV__ (generated at container start);
 * Vite dev uses import.meta.env.
 */
declare global {
  interface Window {
    __ENV__?: Record<string, string | undefined>
  }
}

export function getRuntimeEnv(key: string): string | undefined {
  if (typeof window !== 'undefined' && window.__ENV__ && key in window.__ENV__) {
    const value = window.__ENV__[key]
    return value === undefined || value === '' ? undefined : value
  }
  return (import.meta.env as Record<string, string | undefined>)[key]
}
